import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const footerGuides = [
    { name: "Buying Guide", path: "/article/what-is-oopbuy-spreadsheet" },
    { name: "Comparison Tips", path: "/article/what-is-oopbuy-spreadsheet" },
    { name: "Spreadsheet Tools", path: "/article/what-is-oopbuy-spreadsheet" },
    { name: "Product Sourcing", path: "/article/what-is-oopbuy-spreadsheet" },
  ];

  const footerLegal = [
    { name: "Privacy Policy", path: "#" },
    { name: "Terms of Service", path: "#" },
    { name: "Disclaimer", path: "#" },
  ];

  return (
    <footer className="bg-background-100">
      <div className="mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
            <div className="md:col-span-1">
              <Link to="/" className="text-xl font-bold font-heading text-foreground-950 cursor-pointer">
                OOPBuy Spreadsheet
              </Link>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                Your comprehensive product comparison hub. We help buyers make smarter sourcing decisions with curated spreadsheets, buying guides, and category-based product lists across multiple market segments.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-widest mb-4">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-widest mb-4">
                Guides
              </h4>
              <ul className="space-y-2.5">
                {footerGuides.map((guide) => (
                  <li key={guide.name}>
                    <Link
                      to={guide.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {guide.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-widest mb-4">
                Legal
              </h4>
              <ul className="space-y-2.5">
                {footerLegal.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="flex items-center gap-4 mt-6">
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-100 hover:bg-foreground-200 transition-colors cursor-pointer"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-line text-foreground-700"></i>
                </a>
                <a
                  href="https://instagram.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-100 hover:bg-foreground-200 transition-colors cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-foreground-700"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">Privacy</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">Terms</a>
              <span className="text-foreground-300">|</span>
              <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">Disclaimer</a>
            </div>
            <Link
              to="/"
              className="text-xs text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
            >
              &larr; Back to OOPBuy Spreadsheet Home
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}